var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"trowser",attrs:{"name":"slide-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:['trowser-bar', { absolute: _vm.absolute }]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }